import { Link } from 'react-router-dom';
import {LoyaltyFrame} from "@/components/LoyaltyFrame/LoyaltyFrame.tsx";

export default function LoyaltyPage() {
  return (
    <div className="min-h-screen bg-[#eaf6fb] flex flex-col">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-100 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-3 cursor-pointer">
              <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center">
                <i className="ri-code-s-slash-line text-white text-xl"></i>
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">Рассматриваем заявку</h1>
                <p className="text-xs text-gray-500">Пожалуйста, не закрывайте страницу до завершения рассмотрения заявки</p>
              </div>
            </Link>
            <Link to="/" className="text-sm font-medium text-gray-600 hover:text-teal-600 whitespace-nowrap cursor-pointer">
              <i className="ri-arrow-left-line mr-1"></i>
              На главную
            </Link>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 pt-24 pb-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-[1100px] mx-auto">
          <div className="flex justify-between items-center mb-8 gap-1 flex-wrap flex-col">
            <div className="text-gray-700 text-[40px] font-semibold max-md:text-[40px] text-center">Рассматриваем заявку</div>
            <p className="text-[20px] text-gray-500">Пожалуйста, не закрывайте страницу до завершения рассмотрения заявки</p>
            <div style={{
              display: 'flex',
              gap: '20px',
              marginTop: '20px'
            }}>
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-medium mb-6">
                <i className="ri-money-dollar-circle-line"></i>
                <span>7 500 руб</span>
              </div>
              <div
                  className="inline-flex items-center gap-2 px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-medium mb-6">
                <i className="ri-calendar-line"></i>
                <span>На 16 дней</span>
              </div>
            </div>
          </div>
          <div className="bg-[#f3f4f5] rounded-[28px] p-10 md:p-10 max-md:p-6 max-md:rounded-[22px]"
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >

            <LoyaltyFrame/>

          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center">
                  <i className="ri-code-s-slash-line text-white text-xl"></i>
                </div>
                <div>
                  <h1 className="text-lg font-bold text-white">New Fintech API</h1>
                </div>
              </div>
              <p className="text-sm text-gray-400">
                Финтех решения для современного бизнеса
              </p>
            </div>
            <div>
              <h5 className="text-white font-bold mb-4">Продукт</h5>
              <ul className="space-y-2 text-sm">
                <li><Link to="/#methods" className="hover:text-teal-400 transition-colors">Методы API</Link></li>
                <li><Link to="/pricing" className="hover:text-teal-400 transition-colors">Тарифы</Link></li>
                <li><Link to="/#docs" className="hover:text-teal-400 transition-colors">Документация</Link></li>
                <li><a href="https://newftch.ru/swagger-ui/index.html" target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors">Swagger UI</a></li>
              </ul>
            </div>
            <div>
              <h5 className="text-white font-bold mb-4">Компания</h5>
              <ul className="space-y-2 text-sm">
                <li><Link to="/about" className="hover:text-teal-400 transition-colors">О нас</Link></li>
                <li><a href="https://newfin.tech/consulting" target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors">Консалтинг</a></li>
                <li><Link to="/#contacts" className="hover:text-teal-400 transition-colors">Контакты</Link></li>
              </ul>
            </div>
            <div>
              <h5 className="text-white font-bold mb-4">Поддержка</h5>
              <ul className="space-y-2 text-sm">
                <li><a href="mailto:info@newfin.tech" className="hover:text-teal-400 transition-colors">info@newfin.tech</a></li>
                <li><a href="https://newfin.tech/" target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors">newfin.tech</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-400">
              © 2026 New Fintech API. Все права защищены.
            </p>
            <div className="flex flex-wrap items-center gap-4 text-sm">
              <Link to="/offer" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Публичная оферта</Link>
              <Link to="/agreement" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Пользовательское соглашение</Link>
              <Link to="/privacy" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Политика конфиденциальности</Link>
              <Link to="/legality" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Правовые основания</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
